var exports = {
  "kL": "StickerPreview.module__container___U2dwdD",
  "DD": "StickerPreview.module__title___U2dwdD",
  "i1": "StickerPreview.module__previewContainer___U2dwdD",
  "kH": "StickerPreview.module__previewItem___U2dwdD",
  "u_": "StickerPreview.module__previewBox___U2dwdD",
  "lc": "StickerPreview.module__darkBackground___U2dwdD",
  "x7": "StickerPreview.module__lightBackground___U2dwdD",
  "oz": "StickerPreview.module__previewImage___U2dwdD",
  "Pf": "StickerPreview.module__label___U2dwdD",
};

module.exports = exports;
